import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ValueCache } from '@mpcm/shared';
import { PlatformSupplierBasic } from '@mpsm/shared/domain';

import { ArticleRangeService } from './article-range.service';

@Injectable()
export class SupplierCacheService extends ValueCache<PlatformSupplierBasic> {
  constructor(private readonly articleRangeService: ArticleRangeService) {
    super();
  }

  protected getKey(value: PlatformSupplierBasic): string {
    return value.supplierId;
  }

  protected getValuesByKey(keys: readonly string[]): Observable<readonly PlatformSupplierBasic[]> {
    return this.articleRangeService.getSuppliers({
      supplierIds: keys,
    });
  }
}
